import { render } from "./oficialiaFirmaOficios.vue?vue&type=template&id=3b113f6d&scoped=true"
import script from "./oficialiaFirmaOficios.vue?vue&type=script&lang=js"
export * from "./oficialiaFirmaOficios.vue?vue&type=script&lang=js"

import "./oficialiaFirmaOficios.vue?vue&type=style&index=0&id=3b113f6d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b113f6d"]])

export default __exports__